import React from 'react';

const GroupFundingSection = () => {
  return (
    <section id="group-funding" className="px-4 py-20 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto">
        <div
          className="relative overflow-hidden rounded-3xl border border-gray-700 p-8 sm:p-10 lg:p-12 shadow-2xl"
          style={{ background: 'linear-gradient(135deg, #2d2f33 0%, #1f2937 55%, #0f172a 100%)' }}
        >
          <div
            className="absolute -top-20 -right-20 h-60 w-60 rounded-full blur-3xl"
            style={{ background: 'rgba(255, 255, 255, 0.12)' }}
            aria-hidden="true"
          ></div>
          <div
            className="absolute -bottom-20 -left-20 h-60 w-60 rounded-full blur-3xl"
            style={{ background: 'rgba(59, 130, 246, 0.25)' }}
            aria-hidden="true"
          ></div>

          <div className="relative">
            <div className="inline-flex items-center rounded-full border border-gray-300 bg-gray-800 px-4 py-1 text-xs font-semibold uppercase tracking-wider text-gray-100">
              Integrated Savings and Funding
            </div>

            <h2 className="mt-5 max-w-3xl text-3xl font-semibold text-white sm:text-4xl lg:text-5xl leading-tight">
              Personal Clarity. Community Power.
            </h2>

            <p className="mt-4 max-w-3xl text-base text-gray-200 sm:text-lg leading-relaxed">
              Ajo combines personal money management with community-driven funding. Stay clear on your budget while
              participating in group contribution models that match your shared goals.
            </p>

            <div className="mt-10 grid gap-6 lg:grid-cols-2">
              <article className="rounded-3xl border border-gray-200 bg-white p-6 sm:p-8 transition-transform duration-300 hover:-translate-y-1 hover:shadow-lg">
                <div className="flex items-center justify-between gap-4">
                  <div>
                    <p className="text-xs font-semibold uppercase tracking-widest text-gray-500">Financial Management</p>
                    <h3 className="mt-2 text-2xl font-semibold text-gray-900">Keep a clear view of your money.</h3>
                  </div>
                </div>

                <p className="mt-4 text-sm leading-7 text-gray-600">
                  Build stronger financial habits with a simple dashboard that shows your savings, contributions, and
                  outstanding commitments in real time.
                </p>

                <div className="mt-6 grid gap-4 sm:grid-cols-2">
                  <div className="rounded-2xl bg-gray-50 p-4">
                    <p className="text-xs font-semibold uppercase tracking-wide text-gray-500">Transparency</p>
                    <p className="mt-2 text-sm text-gray-700">Track personal budgets, scheduled contributions, and cash flow without relying on spreadsheets.</p>
                  </div>
                  <div className="rounded-2xl bg-gray-50 p-4">
                    <p className="text-xs font-semibold uppercase tracking-wide text-gray-500">Accountability</p>
                    <p className="mt-2 text-sm text-gray-700">Use reminders and planning tools to stay consistent with your savings goals.</p>
                  </div>
                </div>

                <div className="mt-6 flex flex-wrap gap-2">
                  <span className="rounded-full bg-gray-100 px-3 py-1 text-xs font-medium text-gray-700">Expense tracking</span>
                  <span className="rounded-full bg-gray-100 px-3 py-1 text-xs font-medium text-gray-700">Contribution planning</span>
                  <span className="rounded-full bg-gray-100 px-3 py-1 text-xs font-medium text-gray-700">Goal monitoring</span>
                </div>
              </article>

              <article className="rounded-3xl border border-blue-100 bg-white p-6 sm:p-8 transition-transform duration-300 hover:-translate-y-1 hover:shadow-lg">
                <div className="flex items-center justify-between gap-4">
                  <div>
                    <p className="text-xs font-semibold uppercase tracking-widest text-blue-600">Collaborative Funding</p>
                    <h3 className="mt-2 text-2xl font-semibold text-gray-900">Choose the contribution model that fits your group.</h3>
                  </div>
                </div>

                <div className="mt-6 space-y-4">
                  <div className="rounded-2xl border border-green-100 bg-green-50 p-4">
                    <div className="flex items-center justify-between gap-3">
                      <h4 className="text-lg font-semibold text-gray-900">Regular Group Funding</h4>
                      <span className="rounded-full bg-green-100 px-3 py-1 text-xs font-semibold text-green-800">Fixed Schedule</span>
                    </div>
                    <p className="mt-2 text-sm text-gray-700">Set recurring contribution cycles with automated reminders for groups that prefer structure and predictability.</p>
                  </div>

                  <div className="rounded-2xl border border-blue-100 bg-blue-50 p-4">
                    <div className="flex items-center justify-between gap-3">
                      <h4 className="text-lg font-semibold text-gray-900">Flexi-Group Funding</h4>
                      <span className="rounded-full bg-blue-100 px-3 py-1 text-xs font-semibold text-blue-800">Variable Contributions</span>
                    </div>
                    <p className="mt-2 text-sm text-gray-700">Contribute at your own pace toward a shared target without a mandatory auto-debit schedule.</p>
                  </div>
                </div>
              </article>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default GroupFundingSection;